<template>
  <div>
    <el-form-item label="本店店员：">
      <span v-if="tags.length === 0">暂无</span>
      <el-tag
        v-else
        v-for="tag in tags"
        :key="tag.userName"
        closable
        @close="handleClose(tag)"
      >{{tag.userName}}</el-tag>
    </el-form-item>
    <el-form-item label="选择新店员：" prop="userIds">
      <el-select
        v-model="userIds"
        filterable
        remote
        reserve-keyword
        placeholder="请输入手机号"
        :remote-method="remoteMethod"
        @change="changeChoose"
        @visible-change="visibieChange"
        :loading="selectLoading"
      >
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="item.userName"
          :value="item.id"
        ></el-option>
      </el-select>
      <span class="tips">(仅为手机号搜索)</span>
    </el-form-item>
  </div>
</template>
<script>
import { getShopUserList } from '@/api/stores';
import { validPhone } from '@/utils/validate';

export default {
  data() {
    return {
      selectLoading: false,
      userIds: '',
      options: [],
      tags: [],
      userIdsArray: [],
    };
  },
  props: {
    ids: {
      type: Array,
      required: true,
    },
    newData: {
      type: Array,
      required: true,
    },
  },
  watch: {
    ids: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.userIdsArray = newValue;
        }
      },
      immediate: true,
    },
    newData: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.tags = newValue;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.getShopUserList();
  },
  methods: {
    getShopUserList(query = '') {
      getShopUserList(query).then((res) => {
        if (res.success) {
          this.options = res.data;
          this.selectLoading = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    remoteMethod(query) {
      this.selectLoading = true;
      if (validPhone(query) || query === '') {
        this.getShopUserList(query);
      }
    },
    changeChoose(val) {
      const items = this.options.filter((item) => item.id === val);
      const ishas = this.tags.find((item) => item.id === items[0].id);
      if (!ishas) {
        this.tags = this.tags.concat(items);
        this.userIdsArray.push(items[0].id);
        this.$emit('changeSelect', this.userIdsArray);
      } else {
        this.$message.error('此人已是本店店员');
      }
    },
    handleClose(tag) {
      const { tags } = this;
      this.tags = tags.filter((item) => item.id !== tag.id);
      const index = this.userIdsArray.indexOf(tag.id);
      if (index || index === 0) {
        this.userIdsArray.splice(index, 1);
        this.$emit('changeSelect', this.userIdsArray);
      }
    },
    visibieChange() {
      this.getShopUserList();
    },
  },
};
</script>
<style lang="stylus" scoped>
.el-tag + .el-tag
  margin-left 10px
.tips
  margin-left 10px
  color #ccc
</style>
